/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

/**
 * Správce napájení pro standardní webové technologie.
 * @implements {PowerManager}
 * @memberof AdapterWeb
 */
class PowerManager {
  /**
   * Vytvoří instanci.
   * @returns {PowerManager} Nová instance.
   */
  constructor() {
    this.bootDate = new Date();
  }

  /** @inheritdoc */
  createTimers(powerTasks, timerArray) {
    // TODO #55 Implementovat.
    return Promise.resolve();
  }

  /** @inheritdoc */
  deleteAllTimers() {
    // TODO #55 Implementovat.
    return Promise.resolve();
  }

  /** @inheritdoc */
  getBootDate() {
    return new Promise((resolve) => resolve(this.bootDate));
  }

  /** @inheritdoc */
  reboot() {
    // Web neumožňuje restartovat prohlížeč. Provede pouze restart aplikace.
    return new Promise((resolve) => {
      location.reload();
      return resolve();
    });
  }

  /** @inheritdoc */
  shutdown() {
    // #484 - Prázdná akce na platformě web, ochrana proti ztrátě řízení (původně se načítalo about:blank)
    return Promise.resolve();
  }
}

export default PowerManager;
